import React from "react";
import Services from "../../Layouts/Services/Services";
import BlockChainDevelopment from "../../Home/HomeServicesItBlockCain/BlockChainDevelopment";
import ITservices from "../../Home/HomeServicesItBlockCain/ITservices";
import GameServices from "../../Home/HomeServicesItBlockCain/GameServices";
import "./ServicesPage.css";

const ServicesPage = () => {
  return (
    <div className="services-page-v2026">
      {/* --- Section 1: Clean Text-Only Hero --- */}
      {/* --- Section 1: Dynamic Services Hero --- */}
      <section className="services-hero-clean">
        <div className="services-bg-engine">
          <div className="engine-grid"></div>
          <div className="engine-orb orb-1"></div>
          <div className="engine-orb orb-2"></div>
        </div>

        <div className="services-v2-container">
          <div className="services-hero-content">
            <div className="services-badge-v2">
              <span className="pulse-dot"></span>
              Expert Solutions
            </div>
            <h1 className="services-main-title">
              Engineering{" "}
              <span className="gradient-text">Digital Excellence</span>
            </h1>
            <p className="services-hero-subtitle">
              We architect high-performance ecosystems using the latest
              technological stacks. From Blockchain to AI, we provide end-to-end
              engineering that scales.
            </p>
          </div>
        </div>
      </section>

      {/* --- Section 2: Core Capabilities --- */}
      <Services />

      {/* --- Section 3: Deep Dive Layers --- */}
      <div className="services-layers">
        <ITservices />
        <BlockChainDevelopment />
        <GameServices />
      </div>

      {/* --- Section 4: Final CTA --- */}
      <section className="services-page-cta">
        <div className="services-v2-container">
          <div className="s-cta-box">
            <h2>
              Have a custom project? <br />
              <span>Let's talk technicals.</span>
            </h2>
            <a href="/contactus" className="btn-primary">
              Initialize Consultation
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
